import { Sprout, BookOpen, Plane, Medal, Crown } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { MILESTONES } from '../../utils/cabinI18n';

// Renders on a colored (gradient) banner → light text/icons.
export default function MilestonePath({ overallProgress = 0, completedLessons = 0, totalLessons = 309 }) {
  const { t } = useLanguage();

  const milestoneLabels = {
    beginner:     { label: t('cabin.milestone.beginner'),     Icon: Sprout },
    student:      { label: t('cabin.milestone.student'),      Icon: BookOpen },
    practitioner: { label: t('cabin.milestone.practitioner'), Icon: Plane },
    master:       { label: t('cabin.milestone.master'),       Icon: Medal },
    expert:       { label: t('cabin.milestone.expert'),       Icon: Crown },
  };

  const currentMilestoneIndex = MILESTONES.findIndex(
    (m, i) => overallProgress < m.pct || i === MILESTONES.length - 1
  );

  return (
    <div className="w-full">
      {/* Progress bar */}
      <div className="relative mb-3">
        <div className="h-3 bg-white/25 rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-yellow-300 to-emerald-300 rounded-full transition-all duration-700"
            style={{ width: `${overallProgress}%` }}
            role="progressbar"
            aria-valuenow={overallProgress}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={`${overallProgress}%`}
          />
        </div>
      </div>

      {/* Milestone icons row */}
      <div className="flex items-center justify-between">
        {MILESTONES.map((milestone, idx) => {
          const isPassed = overallProgress >= milestone.pct;
          const isCurrent = idx === currentMilestoneIndex;
          const { label, Icon } = milestoneLabels[milestone.key];
          return (
            <div key={milestone.key} className="flex flex-col items-center gap-1.5">
              <div
                className={`w-9 h-9 rounded-full flex items-center justify-center transition-all ${
                  isPassed
                    ? 'bg-white text-[var(--brand-primary)] shadow-md'
                    : 'bg-white/20 text-white/60'
                } ${isCurrent ? 'ring-2 ring-yellow-300 scale-110' : ''}`}
                title={label}
              >
                <Icon size={18} aria-hidden="true" strokeWidth={2.4} />
              </div>
              <span
                className={`text-[11px] font-semibold hidden sm:block text-center ${
                  isPassed ? 'text-white' : 'text-white/60'
                }`}
              >
                {label}
              </span>
            </div>
          );
        })}
      </div>

      <p className="text-xs text-white/80 mt-3 text-right font-medium">
        {completedLessons}/{totalLessons} ders · %{overallProgress}
      </p>
    </div>
  );
}
